export interface FeaturedRewardProgram {
  logoUrl: string;
  coinModelUrl: string;
}

export const featuredProgramsAssets: { [key: string]: FeaturedRewardProgram } =
  {
    Alchemist: {
      coinModelUrl: '/nft-assets/models/compressed/coin_Alchemist.glb',
      logoUrl: '/nft-assets/logos/mist.png'
    },
    Ampleforth: {
      logoUrl: '/nft-assets/logos/ampl.png',
      coinModelUrl: '/nft-assets/models/compressed/coin_Ampleforth.glb'
    },
    OlympusDAO: {
      logoUrl: '/nft-assets/logos/ohm.png',
      coinModelUrl: '/nft-assets/models/compressed/coin_OlympusDAO.glb'
    },
    Credmark: {
      logoUrl: '/nft-assets/logos/credmark.png',
      coinModelUrl: '/nft-assets/models/compressed/coin_Credmark.glb'
    },
    'Klima DAO': {
      logoUrl: '/nft-assets/logos/klima.png',
      coinModelUrl: '/nft-assets/models/compressed/coin_KlimaDao.glb'
    },
    'MASQ Network': {
      logoUrl: '/nft-assets/logos/masq.png',
      coinModelUrl: '/nft-assets/models/compressed/coin_Masq.glb'
    },
    MASQ: {
      logoUrl: '/nft-assets/logos/masq.png',
      coinModelUrl: '/nft-assets/models/compressed/coin_Masq.glb'
    },
    'CVI Protocol': {
      logoUrl: '/nft-assets/logos/cvi.png',
      coinModelUrl: '/nft-assets/models/compressed/coin_CVI.glb'
    }
  };
